import { format } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'
import { COUNTRY_CA } from '../constants'

export const currencyFormatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD'
})

export const caCurrencyFormatter = new Intl.NumberFormat('en-CA', {
	style: 'currency',
	currency: 'CAD'
})

// Converts +16176063556 to (617) 606-3556
export const formatPhoneNumber = (number) => {
	if (!number) return ''
	if (number.startsWith('+1')) number = number.slice(2, number.length)
	return `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6)}`
}

// Converts (617) 606-3556 or 1617 606-3556 to +16176063556
export const convertPhoneNumberToIntlFormat = (phoneNumber) => {
	// strip all non numric characters
	phoneNumber = phoneNumber.replace(/\D/g, '')
	if (phoneNumber.length === 10) {
		phoneNumber = `+1${phoneNumber}`
	}
	if (phoneNumber.length === 11) {
		phoneNumber = `+${phoneNumber}`
	}
	return phoneNumber
}

/**
 * Format the value (in Dollars, not cents unlike stripeAmountFormatter) for the given currency,
 * Return null if value is null.  Use the clinicCountry from currencyPracticeObject if set.
 * @param {string | numeral} value the value to format
 * @param {*} currencyPracticeObject  the optional currencyPracticeObject
 * @returns the value formatted in the apprioriate currency
 */
export const formatCurrency = (value, currencyPracticeObject) => {
	if (!value) return ''
	if (currencyPracticeObject?.clinicCountry === COUNTRY_CA) {
		return caCurrencyFormatter.format(value)
	}
	return currencyFormatter.format(value)
}

/**
 * @returns the human readable date formatted for the US e.g. Dec 10, 2024
 */
export const formatMediumUSDate = (value) => (value ? format(new Date(value), 'MMM dd, yyyy') : '')

/**
 * @param {Date} value the month expected to be at midnight UTC
 * @returns the mont formatted appropriately so that 2022-12-01T00:00:00Z will be "Dec 2022" even in the western hemisphere, or
 * empty string if not valid
 */
export const formatMonth = (value) =>
	value ? formatInTimeZone(new Date(value), 'Europe/Berlin', 'MMM yyyy') : ''

/**
 * @param {Date} value the day expected to be at midnight UTC
 * @returns the day formatted appropriately with ISO format so that 2022-12-02T00:00:00Z will be "12/02/2022" even in the western hemisphere, or
 * empty string if not valid
 * Note, it uses Berlin intead of UTC/GMT as extra insurance for leap seconds
 */
export const formatUtcIsoDay = (value) =>
	value ? formatInTimeZone(new Date(value), 'Europe/Berlin', 'yyyy-MM-dd') : ''

/**
 * @param {Date} value the day expected to be at midnight UTC
 * @returns the day formatted appropriately with US format so that 2022-12-02T00:00:00Z will be "2022-12-02" even in the western hemisphere, or
 * empty string if not valid
 */
export const formatUtcDay = (value) =>
	value ? formatInTimeZone(new Date(value), 'Europe/Berlin', 'MM/dd/yyyy') : ''

/**
 * @returns  the current timezone
 */
export const getTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone

/**
 * @returns the date suffix to put at the end of an export file
 */
export const getFileDateSuffix = () => format(new Date(), 'yyyyMMdd-HHmm')

export const percentageFormatter = (value) => (value ? `${(value * 100).toFixed(2)}%` : '')

export const dollarFormatter = (value) => (value ? `${value}$` : '')
